module.exports = __webpack_public_path__ + "img/c.abc0a703.jpg";